import { render, staticRenderFns } from "./GaugeRecuperator.vue?vue&type=template&id=277cd52c&scoped=true&"
import script from "./GaugeRecuperator.vue?vue&type=script&lang=js&"
export * from "./GaugeRecuperator.vue?vue&type=script&lang=js&"
import style0 from "./GaugeRecuperator.vue?vue&type=style&index=0&id=277cd52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277cd52c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VImg,VRow})
